import React from 'react';

function Error() {
    return (
        <>
            <h2>Fehler - Komponente nicht gefunden</h2>
            <p>Die angeforderte Komponente konnte nicht gefunden werden.</p>
        </>
    );
}

export default Error;